import React from "react";
import propTypes from "prop-types";
import clsx from "clsx";
import styles from "./Banner.module.css";

const Banner = ({ children, heading, addMargin, secondary, headingCenter }) => {
  return (
    <div
      className={clsx(
        styles.banner,
        addMargin && styles.margin,
        secondary && styles.secondary
      )}
    >
      <div className="container">
        <h5 className={clsx("pt-3 pb-1", headingCenter && "text-center")}>
          {heading}
        </h5>
        <div className={clsx("py-2 text-left", styles.text)}>
          <p>{children}</p>
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  to: propTypes.string,
  children: propTypes.node,
  heading: propTypes.node,
  secondary: propTypes.bool,
  className: propTypes.string,
};
export default Banner;
